import Modal from './Modal'

interface ConfirmDialogProps {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  destructive?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title} size="sm" persistent>
      <p className="text-body text-sm mb-6 leading-relaxed">{message}</p>
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="btn-ghost flex-1"
        >
          {cancelLabel}
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 py-2.5 rounded-ab font-display font-bold text-sm transition-all"
          style={{
            background: destructive ? '#FF4800' : undefined,
            color: '#fff',
          }}
        >
          {!destructive ? (
            <span className="btn-primary w-full">{confirmLabel}</span>
          ) : (
            confirmLabel
          )}
        </button>
      </div>
    </Modal>
  )
}
